import {Nullable, QuestionStatisticsType} from "../../definitions/types";
import {defaultQuestionStatistics} from "../../utils/constants";

export class QuestionStatisticsModel {
    private readonly _count?: number;
    private readonly _answeredCount?: number;
    private readonly _unansweredCount?: number;

    constructor(questionStatistics: Nullable<QuestionStatisticsType>) {
        this._count = questionStatistics?.count;
        this._answeredCount = questionStatistics?.answeredCount;
        this._unansweredCount = questionStatistics?.unansweredCount;
    }

    /**
     * @method count
     * @description Returns the number of questions for the product.
     * @returns {number}
     */
    public get count(): number {
        return this._count ?? defaultQuestionStatistics.count;
    }

    /**
     * @method answeredCount
     * @description Returns the number of answered questions for the product.
     * @returns {number}
     */
    public get answeredCount(): number {
        return this._answeredCount ?? defaultQuestionStatistics.answeredCount;
    }

    /**
     * @method unansweredCount
     * @description Returns the number of unanswered questions for the product.
     * @returns {number}
     */
    public get unansweredCount(): number {
        return this._unansweredCount ?? defaultQuestionStatistics.unansweredCount;
    }
}